import { getLocalizedApiName, LocalizedApiName } from "../../../utils/i18n/getLocalizedApiName";

type ManagementType = {
  id: number;
  name: string | LocalizedApiName;
  monitoring_types: { name: string | LocalizedApiName }[];
};

// Dropdown domain labels stay in their original language when the UI changes.
const optionName = (name: string | LocalizedApiName) => getLocalizedApiName(name, "pt-BR");

export function managementTypeOption(type: ManagementType) {
  return { label: optionName(type.name), value: type.id, info: type.monitoring_types };
}

export function managementGroupOption<T extends { management_type: ManagementType; management_group_id: number }>(group: T) {
  const type = group.management_type;
  return {
    label: `${optionName(type.name)} - ${type.monitoring_types.map(monitor => optionName(monitor.name)).join(",")}`,
    value: group.management_group_id,
    info: group,
  };
}
